import locations from 'routes';

const HIDE_SUB_NAV_PATH_NAMES: string[] = [
  locations.loginMSCallback(),
  locations.loginOktaCallback(),
  locations.loginMSPage(),
  locations.loginEmail(),
  locations.loginForm(),
  locations.welcomeWizard(),
];

export const shouldHideSubNavByPath = (pathname: string) => {
  return HIDE_SUB_NAV_PATH_NAMES.includes(pathname);
};
